import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate, AuthCallback } from '@aosenuma/lib-supabase';
import { EncuestaLauncher } from '@aosenuma/encuestas';

// Lazy: el Dashboard arrastra mapbox-gl + react-map-gl (~1.5MB).
// No tiene sentido descargarlo antes de que AuthGate pase. Usuarios no
// autenticados se redirigen a landing sin tocar el chunk del visor.
const Dashboard = lazy(() =>
  import('@/pages/Dashboard').then((m) => ({ default: m.Dashboard })),
);

// Solo DEV: preview del wizard de encuestas con datos mock (sin auth ni DB).
const DevEncuestaPreview = import.meta.env.DEV
  ? lazy(() =>
      import('@/pages/DevEncuestaPreview').then((m) => ({ default: m.DevEncuestaPreview })),
    )
  : null;

const URL_LANDING = import.meta.env.VITE_PUBLIC_URL_LANDING ?? 'http://localhost:5173';

// Fail-fast: en prod, falta de env = redirección silenciosa a localhost.
if (import.meta.env.PROD && !import.meta.env.VITE_PUBLIC_URL_LANDING) {
  throw new Error('VITE_PUBLIC_URL_LANDING requerido en producción');
}

const Loading = () => (
  <div
    style={{
      minHeight: '100dvh',
      display: 'grid',
      placeItems: 'center',
      background: 'var(--bg-deep, #0a1118)',
      color: 'var(--text-mid, rgba(255,255,255,0.78))',
      fontSize: 13,
      fontFamily: 'Inter, system-ui, sans-serif',
    }}
  >
    Cargando…
  </div>
);

export function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback redirectTo="/" />} />
      {DevEncuestaPreview && (
        <Route
          path="/dev/encuesta"
          element={
            <Suspense fallback={<Loading />}>
              <DevEncuestaPreview />
            </Suspense>
          }
        />
      )}
      <Route
        path="*"
        element={
          <AuthGate
            allowed={['cliente_elawan']}
            panelScope="cliente"
            unauthenticated={URL_LANDING}
            forceEnroll
            mfaTtlMs={8 * 60 * 60 * 1000}
          >
            {/* Encuesta de evaluación post-login (audiencia cliente). Overlay
                no bloqueante del chunk del visor: se monta junto al Suspense. */}
            <EncuestaLauncher audiencia="cliente" />
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </AuthGate>
        }
      />
    </Routes>
  );
}
